import React, { useContext } from "react";
import "./Select.css";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../../../..";

const Select = ({
  label,
  options,
  name,
  register,
  errors,
  mandatory,
  defaultselect = false,
  disabled ,
  style
}) => {
  const { onChange, ...params } = register(name);
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);

  return (
    <div>
      <label className="form__label">
        {t(label)}
        {mandatory && <span className="asterisk">*</span>}
      </label>
      <select
      style={style}
      className={`form-select ${errors[name] ? "form__select--errorborder" : "form__select"
      } ${theme === "light" ? "form__select_light" : ""}`}
        {...params}
        onChange={onChange}
        disabled={disabled}
        id={name}>
        {defaultselect && (
          <option selected className="text-muted" value="">
            Select option
          </option>
        )}

        {options?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <p className="error__message">{errors[name]?.message}</p>
    </div>
  );
};
export default Select;
